import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserService } from '@core/auth/user/user.service';

const AUTH_BYPASS_ROUTES = [
  'auth/login',
  'auth/login/verifyOtp',
  'auth/register',
  'auth/sendOtp',
  'auth/verifyOtp',
  'auth/forgotPasswordEmail',
  'site-settings'
];

export const newAuthHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const userService = inject(UserService);

  const isAuthRoute = AUTH_BYPASS_ROUTES.some(path => req.url.includes(path));
  if (!isAuthRoute && userService.loginData?.authtoken) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${userService.loginData.authtoken}`
      }
    });
  }

  return next(req);
};
